module.exports = __webpack_public_path__ + "static/media/banking.7510e8ba.jpg";